import {analytics} from '@cl/shared';
import _forEach from 'lodash/forEach';
import _partition from 'lodash/partition';
import {MetricValue} from '../analytics.types';
const {cachedAnalyticsSubject} = analytics;

export default function extractCustomConversionsFromMetrics(metrics: MetricValue[]) {
  const customConversions = new Set<string>();

  const cachedCustomConversions = [
    ...(cachedAnalyticsSubject.data.optionsByMetricsKey[MetricValue.CustomConversions] ?? []),
    ...(cachedAnalyticsSubject.data.optionsByMetricsKey[MetricValue.CustomMetaConversions] ?? []),
  ];

  _forEach(cachedCustomConversions, ({value}) => {
    customConversions.add(value);
  });

  return _partition(metrics, (metric) => customConversions.has(metric));
}
